//@ts-nocheck
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withFormik } from 'formik'
import styled from 'styled-components'
import Router, { withRouter } from 'next/router'

import { Container, Row, Col, Checkbox, Button, Radio, Spinner } from '@mch-group/uikit-components'

import { setMe } from '@stores/user'

import { User as UserService } from '../../../services'
import Text from '../../Text'
import { px2rem } from '../../../utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const mID = 'preferences-form'

const ContactPreferencesFormComponent = ({ className, router, ...props }) => {
  const { values, isSubmitting, handleBlur, handleSubmit, submitForm } = props
  const isUnsubscribePage = router?.query?.slug?.includes('/unsubscribe')

  const onChangeNewsLetter = () => {
    values.newsletterSubscribed = !values.newsletterSubscribed
    submitForm()
  }

  const onChangePressReleases = () => {
    values.pressReleaseSubscribed = !values.pressReleaseSubscribed
    submitForm()
  }

  const onChangeLanguagePreference = (event) => {
    if (values.preferedLanguage !== event.target.value) {
      values.preferedLanguage = event.target.value
      submitForm()
    }
  }

  return (
    <div className={className}>
      <div className={mID}>
        <form onSubmit={handleSubmit}>
          <Container>
            {props.data.uco_grp1_label1 && (
              <Row className={`${mID}__newsletter`}>
                <Col>
                  <Checkbox
                    id='newsletterSubscribed'
                    label={props.data.uco_grp1_label1}
                    onChange={onChangeNewsLetter}
                    checked={values.newsletterSubscribed}
                    onBlur={handleBlur}
                    disabled={isSubmitting}
                    />
                  <div
                    className={`${mID}__label`}
                    tabIndex={0}
                    role='link'
                    onKeyUp={onChangeNewsLetter}
                    onClick={onChangeNewsLetter}
                    >
                    <Text isSmall isHtml>
                      {props.data.uco_grp1_desc1}
                    </Text>
                  </div>
                </Col>
              </Row>
            )}
            {props.data.uco_grp1_label2 && (
              <Row className={`${mID}__subscribe`}>
                <Col>
                  <Checkbox
                    id='pressReleaseSubscribed'
                    label={props.data.uco_grp1_label2}
                    onChange={onChangePressReleases}
                    checked={values.pressReleaseSubscribed}
                    onBlur={handleBlur}
                    disabled={isSubmitting}
                    />
                  <div
                    className={`${mID}__label`}
                    tabIndex={0}
                    role='link'
                    onKeyUp={onChangeNewsLetter}
                    onClick={onChangeNewsLetter}
                    >
                    <Text isSmall isHtml>
                      {props.data.uco_grp1_desc2}
                    </Text>
                  </div>
                </Col>
              </Row>
            )}
            {props.data.uco_grp1_lan_title && (
              <Row className={`${mID}__language`}>
                <Col>
                  <h4>{props.data.uco_grp1_lan_title}</h4>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <Row className={`${mID}__languages flex-row`}>
                  {props.preferedLanguages && (props.data.uco_grp1_lan1 || props.data.uco_grp1_lan2) && (
                    <>
                      <Col className={`${mID}__language--item`} computer={9} tablet={12} mobile={12}>
                        <div id='preferedLanguage' name='preferedLanguage' className='d-flex gap-4'>
                          {props.preferedLanguages.length === 3 && (
                            <>
                              <Radio
                                id={parseInt(props.preferedLanguages[1].code, 10)}
                                name='radio-canvas'
                                label={props.data.uco_grp1_lan1
                                  ? props.data.uco_grp1_lan1 : props.preferedLanguages[1].value}
                                //@ts-ignore
                                onChange={onChangeLanguagePreference}
                                value={props.preferedLanguages[1]?.code}
                                checked={values.preferedLanguage == props.preferedLanguages[1].code}
                                disabled={isSubmitting}
                              />
                              <Radio
                                id={parseInt(props.preferedLanguages[0].code, 10)}
                                name='radio-canvas'
                                label={props.data.uco_grp1_lan2
                                  ? props.data.uco_grp1_lan2 : props.preferedLanguages[0].value}
                                //@ts-ignore
                                onChange={onChangeLanguagePreference}
                                value={props.preferedLanguages[0]?.code}
                                checked={values.preferedLanguage == props.preferedLanguages[0].code}
                                disabled={isSubmitting}
                              />
                              <Radio
                                id={parseInt(props.preferedLanguages[2].code, 10)}
                                name='radio-canvas'
                                label={props.data.uco_grp1_lan3
                                  ? props.data.uco_grp1_lan3 : props.preferedLanguages[2].value}
                                //@ts-ignore
                                onChange={onChangeLanguagePreference}
                                value={props.preferedLanguages[2]?.code}
                                checked={values.preferedLanguage == props.preferedLanguages[2].code}
                                disabled={isSubmitting}
                              />
                            </>
                          )}
                          {props.preferedLanguages.length === 1 && (
                          <Radio
                            id={parseInt(props.preferedLanguages[0].code, 10)}
                            name='radio-canvas'
                            label={props.data.uco_grp1_lan1
                              ? props.data.uco_grp1_lan1 : props.preferedLanguages[0].value}
                             //@ts-ignore
                            onChange={onChangeLanguagePreference}
                            value={props.preferedLanguages[0].code}
                            checked={values.preferedLanguage == props.preferedLanguages[0].code}
                            disabled={isSubmitting}
                           />
                          )}
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </Col>
            </Row>
            <div style={{ height: 0, paddingTop:'32px' }}>
              {isSubmitting && <Spinner variant='button' />}
            </div>
            {!isUnsubscribePage && (
              <Row className='mt-8'>
                <Col>
                  <h3>{props.data.ude_grp1_reset_password_title} </h3>
                  <p>{props.data.ude_grp1_reset_password_sub_title}</p>
                  <Button
                    variant='primary'
                    onClick={() => {
                      Router.push({ pathname: '/' }, '/reset-password')
                    }}
                  >
                    {props.data.ude_grp1_create_password_button_text}
                  </Button>
                </Col>
              </Row>
            )}
          </Container>
        </form>
      </div>
    </div>
  )
}

ContactPreferencesFormComponent.propTypes = {
  data: PropTypes.object,
  values: PropTypes.object,
  isSubmitting: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitForm: PropTypes.func,
  preferedLanguages: PropTypes.array,
  className: PropTypes.string,
  unsubscribeData: PropTypes.object,
  unsubscribeUrl: PropTypes.object,
  unsubscribeLoginStatus: PropTypes.bool
}

const ContactPreferencesForm = withFormik({
  mapPropsToValues: (props) => {
    // unsubscribe page
    if (props.unsubscribeData) {
      return {
        newsletterSubscribed: props.unsubscribeData.newsletterSubscribed || false,
        pressReleaseSubscribed: props.unsubscribeData.pressReleaseSubscribed || false,
        preferedLanguage: Number(props.unsubscribeData.preferedLanguage),
        userCrmGuid: !props.unsubscribeLoginStatus ? props.unsubscribeUrl.userCrmGuid : undefined,
        token: !props.unsubscribeLoginStatus ? props.unsubscribeUrl.crmToken : undefined
      }
    }
    // dashboard page
    return {
      newsletterSubscribed: props.user.newsletterSubscribed || false,
      pressReleaseSubscribed: props.user.pressReleaseSubscribed || false,
      preferedLanguage: Number(props.user.preferedLanguage)
    }
  },
  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    const isDashboardPage = !props.unsubscribeData || (props.unsubscribeData && props.unsubscribeLoginStatus)
    const isSubscribePage = props.unsubscribeData && props.unsubscribeUrl && !props.unsubscribeLoginStatus

    // dashboard page
    if (isDashboardPage) {
      UserService.updateUserPreferences(values)
        .then((response) => {
          if (response.status === 200) {
            setMe(response.data)
            setSubmitting(false)
          } else {
            props.setFormError(props.store.valmsg_ensure_all_info_correct)
            resetForm()
            setSubmitting(false)
          }
        })
        .catch((errors) => {
          props.setFormError(JSON.stringify(errors))
          resetForm()
        })
    }
    // unsubscribe page
    if (isSubscribePage) {
      UserService.updateSubscriptions(values).then(
        () => {
          setSubmitting(false)
        },
        () => {
          setSubmitting(false)
        }
      )
    }
  }
})(ContactPreferencesFormComponent)

const StyledComponent = styled(ContactPreferencesForm)`
  .${mID} {
    &__label {
      padding-left: 20px;
      cursor: pointer;
    }

    .ui.grid &__language {
      padding-bottom: 0;
      padding-top: 0;

      &--item {
        @media (max-width: 1023px) {
          padding-bottom: 20px;
        }

        &:first-child {
          order: 2;
        }

        &:last-child {
          order: 1;
        }
      }
    }

    label {
      font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      color: var(--bs-mch-black);
    }

    &__newsletter.row {
      padding-bottom: 0;
      margin-bottom: 4px;
    }

    &__subscribe.row {
      padding-bottom: 0;
      margin-bottom: 50px;

      @media (max-width: 767px) {
        margin-bottom: 21px;
      }
    }

    &__languages.row {
      padding-top: ${px2rem(6)};

      @media (max-width: 767px) {
        padding-bottom: 0;
      }
    }
  }
`
export default withRouter(StyledComponent)
